export default __webpack_public_path__ + "static/media/winding-down.88c2b9de.svg";